
import { Component, Vue } from 'vue-property-decorator'
import moment from "moment";
@Component({
  name: 'DatetimePickerDialog'
})
export default class DatetimePickerDialog extends Vue {
  showDialog = false
  currentDate = new Date()
  minDate = new Date()


  show (data) {
    this.showDialog = true
  }

  onCancel () {
    this.showDialog = false
  }

  onConfirm () {
    let dateTime = moment(this.currentDate).format("YYYY-MM-DD")
    this.$emit('getDateTime', dateTime)
    this.showDialog = false
  }
}
